import { Component } from '@angular/core';
import { LoginComponent } from '../cognito/login.component';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [LoginComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

}
